const bazarListPk = {
	banner: {
		title: 'بازار',
		subtitle: 'ہزاروں روایتی دیہی بازاروں سے خریداری کریں',
		breadcrumbLabel: 'بازار',
		currentPlaceholder: 'کھانا تلاش کریں...'
	},
	filter: {
		title: 'فلٹر آپشنز',
		searchPlaceholder: 'بازار تلاش کریں...',
		district: 'ضلع',
		upazilla: 'تحصیل',
		size: 'بازار کا سائز',
		sortBy: 'ترتیب دیں',
		sortOptions: {
			name: 'نام',
			storeCount: 'دکانوں کی تعداد',
			rating: 'ریٹنگ',
			visitors: 'مقبولیت'
		},
		clearShort: 'صاف کریں',
		clearAll: 'تمام صاف کریں',
		activeFilters: 'فعال فلٹرز:',
		labels: {
			search: 'تلاش',
			district: 'ضلع',
			upazilla: 'تحصیل',
			size: 'سائز'
		}
	},
	results: {
		foundSuffix: 'بازار ملے',
		none: 'کوئی بازار نہیں ملا',
		page: 'صفحہ'
	},
	empty: {
		title: 'آپ کی تلاش کے مطابق کوئی بازار نہیں ملا',
		subtitle: 'مختلف فلٹر آزما کر دیکھیں یا تمام فلٹر صاف کریں',
		clear: 'تمام فلٹر صاف کریں'
	},
	card: {
		stores: 'دکانیں',
		dailyVisitors: 'یومیہ وزیٹرز',
		specialties: 'خصوصیات:',
		details: 'تفصیل',
		visit: 'وزٹ کریں'
	},
	dialog: {
		title: 'مبارک ہو!',
		selected: 'آپ کا بازار منتخب ہو گیا',
		instruction: 'آپ کا موجودہ بازار منتخب کر لیا گیا ہے۔ نیچے سے وہ کیٹیگری منتخب کریں جس میں آپ خریداری کرنا چاہتے ہیں:',
		categoryPrompt: 'آپ کیا خریدنا چاہتے ہیں؟',
		bottomNotePrefix: 'یہ مصنوعات',
		bottomNoteSuffix: 'سے فراہم کی جائیں گی',
		close: 'بعد میں دیکھوں گا'
	}
};

export default bazarListPk;


